import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Rating from '@mui/material/Rating';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const quoteContainerSx: SxProps = {
  maxWidth: { xs: 'none', md: 300 },
  margin: { xs: '1.5rem 1.5rem -2rem', md: '1.5rem' },
};

const imageContainerSX: SxProps = {
  backgroundImage: 'url("/testimonial/bg.jpg")',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top right',
  position: { xs: 'static', md: 'absolute' },
  width: '100%',
  height: { xs: '400px', md: '100%' },
  top: 0,
  left: 0,
};

export const Testimonial = () => {
  return (
    <Box minWidth="100%" borderRadius="10px" bgcolor="#a69f98" position="relative" overflow="hidden">
      <Box sx={quoteContainerSx}  position="relative" zIndex={1}>
        <Quote />
      </Box>
      <Box sx={imageContainerSX} />
    </Box>
  );
};

const Quote = () => {
  return (
    <Box bgcolor="rgba(255,255,255,0.4)" borderRadius="0.75rem" px={1} py={1.5}>
      <Card elevation={3} sx={{ borderRadius: '0.5rem' }}>
        <CardContent>
          <Box textAlign="center">
            <Typography variant="body2" color="textSecondary">
              Losing a pet is one of the hardest things we can go through, but LGCY Pet has helped us to keep our
              precious memories alive. The pictures and keepsakes bring back those happy moments, offering
              comfort when we miss our girl, Stella. We are so grateful for this beautiful way to honor her.
            </Typography>
            <Rating value={5} readOnly />
            <Typography variant="subtitle2" color="textSecondary" fontWeight="bold" textTransform="uppercase">
              Buffy S.
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
